import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';
import { MenuComponent } from '../menu/menu.component';
import { SimuladorService } from './../../datos/simulador.service';
import { JsonResponse } from './../../libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, ElementoDTO, EspacioDTO, EspacioForm, InputObtenerCostoManoObra, InputObtenerCostoPrecioUnitarioMateriales, InputObtenerCostoTotalManoObraXElemento, InputObtenerCostoTotalMaterialesXElemento, InputObtenerEspacioDetalle, InputObtenerEspacio_Pages, InputObtenerPrototipo_Pages, InputObtenerReporte, OutputObtenerCostoManoObra, OutputObtenerCostoPrecioUnitarioMateriales, OutputObtenerCostoTotalManoObraXElemento, OutputObtenerCostoTotalMaterialesXElemento, OutputObtenerElementos, OutputObtenerEspacioDetalle, OutputObtenerEspacio_Pages, OutputObtenerPrototipoDetalle, OutputObtenerPrototipo_Pages, PersonalDTO, PrototipoDTO, PrototipoForm, SelectItemGroups, TipoEspacioDTO, TipoPrototipoDTO, UnidadMedidaDTO, InputObtenerCostoExcelExplosionTotalMateriales, OutputObtenerCostoExcelExplosionTotalMateriales, InputObtenerCostoExcelExplosionXConcepto, OutputObtenerCostoExcelExplosionXConcepto, InputObtenerCostoExcelTotalManoObra, OutputObtenerCostoExcelTotalManoObra, InputObtenerCostoTotalExcelPresupuestoPrototipo, OutputObtenerCostoTotalExcelPresupuestoPrototipo, InputObtenerCostoTotalExcelPrototipo, OutputObtenerCostoTotalExcelPrototipo, $Elementos, ItemGroups, Item, InputObtenerReportePrototipo, Espacios, Totales, $Espacio, CostoTotalExcelPresupuestoPrototipoDTO, ElementoEspDTO, InputObtenerDocuemntosXPrototipo, DocuemntosXPrototipoDTO, OutputObtenerDocuemntosXPrototipo } from './../../modelo';

@Component({
    selector: 'app-simulador-prototipos',
    templateUrl: './simulador-prototipos.component.html',
    styleUrls: ['../../../assets/css/styles.css']
})
export class SimuladorPrototiposComponent implements OnInit {

    public datosElemento: DatosElementoDTO;
    public itemGroupsPrototipos: ItemGroups<PrototipoDTO>;
    public listaEspacios: $Espacio[];
    public Total: number = 0;
    public TotalMateriales: number;
    public TotalManoObra: number;
    public TotalPresupuesto: number;
    public $Total: number;
    public SubTotal: number;
    public Indirecto: number;
    public CostoTotalProyecto = 0;
    public ConAsistenciaTecnica: number = 0;
    public ConConstructora: number = 0;
    public tipoVivienda: string = '0';
    public tipoAsistencia: string = '0';
    public Economico: number = 0;
    public Medio: number = 0;
    public Alto: number = 0;
    public clave: string = '';
    public prototipo: Item<PrototipoDTO>;
    public activeTab: string = 'pestana3';
    public listaCostoExcelExplosionTotalMateriales: OutputObtenerCostoExcelExplosionTotalMateriales[] = [];
    public listaCostoExcelTotalManoObra: OutputObtenerCostoExcelTotalManoObra[] = [];
    public listaCostoTotalExcelPresupuestoPrototipo: OutputObtenerCostoTotalExcelPresupuestoPrototipo[] = [];
    public groupCostoTotalExcelPresupuestoPrototipo: CostoTotalExcelPresupuestoPrototipoDTO[] = [];
    public modalTotales: boolean = false;

    public titulo: string;
    public modalPresupuesto: boolean = false;
    public modalManoObra: boolean = false;
    public modalMateriales: boolean = false;
    public listaDocumentos: DocuemntosXPrototipoDTO;
    public listDocument: OutputObtenerDocuemntosXPrototipo[] = [];
    public tituloModal: string;
    private listEtapas: any[];

    //Menu
    public menu: MenuComponent;

    /**
     * 
     * @param messageService
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private messageService: MessageService, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    ngOnInit(): void {

        this.itemGroupsPrototipos = <ItemGroups<PrototipoDTO>>{ length: 0, list: [] };

        this.clave = this.getClave();

        this.loading();
    }

    /**
     * 
     */
    private async loading() {

        let usuario = HttpSession.getAttribute('USER_NAME');

        let isAdministrador: boolean = false;

        if (usuario != null) {
            isAdministrador = true;
        }

        let datosElemento: JsonResponse<DatosElementoDTO> = null;

        // Obtener Elementos
        {
            datosElemento = await this.service.ObtenerElementos().toPromise();

            this.datosElemento = datosElemento.model;
        }

        this.getListElementos();

        //Obtener Prototipos
        {
            let data: InputObtenerPrototipo_Pages = <InputObtenerPrototipo_Pages>{ tamanioPagina: 9000, pagina: 1 };

            let resultado: JsonResponse<OutputObtenerPrototipo_Pages> = await this.service.ObtenerPrototipoPages(data).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                let listPrototipos: PrototipoDTO[] = resultado.model.listPrototipo;

                if (isAdministrador != null && isAdministrador == false) {
                    listPrototipos = listPrototipos.filter(row => row.activo == true);
                }

                this.itemGroupsPrototipos = <ItemGroups<PrototipoDTO>>{ list: [] };

                for (let row of listPrototipos) {

                    let item: Item<PrototipoDTO> = <Item<PrototipoDTO>>{
                        label: `${row.nombreTipoPrototipo}-${row.nombrePrototipo}`,
                        entity: row,
                        checked: false
                    };

                    this.itemGroupsPrototipos.list.push(item);

                }

            }

        }

    }

    /**
     * 
     */
    public getListElementos(): $Elementos<ElementoEspDTO>[] {

        let listElementos: $Elementos<ElementoEspDTO>[] = [];

        if (this.datosElemento != null && this.datosElemento.listElementoEsp != null) {

            let filter = this.datosElemento.listElementoEsp

            for (let row of filter) {

                let entity: $Elementos<ElementoEspDTO> = <$Elementos<ElementoEspDTO>>{ value: row.idElementoEsp, label: row.nombreElementoEsp, entity: row, checked: false, total: 0, disabled: true };

                listElementos.push(entity);
            }

        }

        return listElementos;
    }


    /**
     * 
     * @param entity
     * @param clearLista
     */
    public async onClickCheckboxPrototipo(entity: Item<PrototipoDTO>, clearLista: boolean) {

        this.prototipo = entity;

        if (clearLista == true) {

            this.listaEspacios = [];
            this.clave = this.getClave();
            this.onChangeTipoAsistencia();

        } else {

            for (let espacios of this.listaEspacios) {

                espacios.total = 0;
                espacios.totalObligatorios = 0;
                espacios.totalOpcionales = 0;

                for (let elementos of espacios.listElementos) {
                    elementos.total = 0;
                }
            }

        }

        if (entity != null) {

            //Obtener documentos x Prototipo
            {
                let dato: InputObtenerDocuemntosXPrototipo = <InputObtenerDocuemntosXPrototipo>{ idPrototipo: this.prototipo.entity.idPrototipo };

                let resultado: JsonResponse<DocuemntosXPrototipoDTO> = await this.service.ObtenerDocuemntosXPrototipo(dato).toPromise();

                if (resultado != null && resultado.code == 200 && resultado.model != null) {
                    this.listaDocumentos = resultado.model;

                    console.log('this.listaDocumentos -->> ', this.listaDocumentos)
                }
            }

            {

                let data: InputObtenerCostoTotalExcelPrototipo = <InputObtenerCostoTotalExcelPrototipo>{
                    clave: this.clave,
                    clavePU: this.getClavePU(),
                    idPrototipo: entity.entity.idPrototipo,
                    esAcabado: true
                };

                let resultado: JsonResponse<OutputObtenerCostoTotalExcelPrototipo[]> = await this.service.ObtenerCostoTotalExcelPrototipo(data).toPromise();

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    let lista: OutputObtenerCostoTotalExcelPrototipo[] = resultado.model;

                    if (lista != null && lista.length > 0) {

                        for (let row of lista) {

                            let checked: boolean = false;

                            if (row.idEtapaPrototipo == 1) {
                                checked = true;
                            }

                            let espacio: $Espacio = <$Espacio>{ id: row.idEspacio, nombre: row.nombreEspacio, entity: row, listElementos: this.getListElementos(), total: 0, totalObligatorios: 0, totalOpcionales: 0, checked: checked, checkAll: false, value: 'false' };

                            let filterEspacios = this.listaEspacios.filter(item => item.id == row.idEspacio);

                            if (filterEspacios != null && filterEspacios.length > 0) {
                                this.setTotalesXElemento(filterEspacios[0], row);
                            } else {
                                this.setTotalesXElemento(espacio, row);
                                this.listaEspacios.push(espacio);
                            }
                        }
                    }

                    // Remover Elementos de ObtenerCostoTotalExcelPrototipo que no sean acabados

                    for (let row of this.listaEspacios) {

                        let filter = row.listElementos.filter(entity => entity.disabled == false);

                        row.listElementos = filter;

                    }

                }
            }

            {

                let data: InputObtenerCostoTotalExcelPrototipo = <InputObtenerCostoTotalExcelPrototipo>{
                    clave: this.clave,
                    clavePU: this.getClavePU(),
                    idPrototipo: entity.entity.idPrototipo,
                    esAcabado: false
                };

                let resultado: JsonResponse<OutputObtenerCostoTotalExcelPrototipo[]> = await this.service.ObtenerCostoTotalExcelPrototipo(data).toPromise();

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    let lista: OutputObtenerCostoTotalExcelPrototipo[] = resultado.model;

                    if (lista != null && lista.length > 0) {

                        for (let row of lista) {

                            let filter = this.listaEspacios.filter(item => item.id == row.idEspacio);

                            if (filter != null && filter.length > 0) {

                                filter[0].totalObligatorios += row.subtotal;

                            }

                        }
                    }

                }
            }

            this.activeTab = 'pestana4';

            this.itemGroupsPrototipos.length = 1;

            this.sumarAcabados();

            this.onChangeTipoAsistencia();

            switch (this.tipoVivienda) {
                case '0': this.Economico = this.Total; break;
                case '1': this.Medio = this.Total; break;
                case '2': this.Alto = this.Total; break;
            }

            this.setListEtapas();

            if (this.listEtapas != null && this.listEtapas.length >= 1 && this.listEtapas[1] == true) {
                this.CostoTotalProyecto = 0;
                this.listaEspacios[0].totalObligatorios = 0;
                this.listaEspacios[0].totalOpcionales = 0;
                this.listaEspacios[0].total = 0;
            }

        }
    }

    /**
     * 
     */
    private setListEtapas(): void {

        if (this.listEtapas == null) {

            if (this.listaEspacios != null) {

                let listEtapas: boolean[] = [];

                for (let x = 0; x < this.listaEspacios.length; x++) {
                    listEtapas.push(true);
                }

                if (this.listaEspacios.length >= 2) {
                   // listEtapas[0] = false;
                    //listEtapas[1] = false;
                }

                this.listEtapas = listEtapas;
            }

        }

    }

    /**
     * 
     * @param espacio
     * @param row
     */
    private setTotalesXElemento(espacio: $Espacio, row: OutputObtenerCostoTotalExcelPrototipo): void {

        let filter = espacio.listElementos.filter(item => item.value == row.idElementoEsp);

        if (filter != null && filter.length > 0) {
            filter[0].total += row.subtotal;
            filter[0].disabled = false;
        }
    }



    /**
     * 
     * @param entity
     */
    public onClickCheckboxElemento(row: any, entity: $Elementos<OutputObtenerElementos>): void {

        if (entity.checked == false) {
            row.checkAll = false;
        }

        this.onChangeTipoVivienda();

    }

    /**
     * 
     * @param entity
     */
    public async checkAll(entity: $Espacio) {

        for (let row of entity.listElementos) {

            if (row.total > 0) {
                row.checked = entity.checkAll;
            }
        }

        this.onChangeTipoVivienda();
    }

    /**
     * 
     * 
     */
    private sumarAcabados(): void {

        this.Total = 0;

        for (let espacio of this.listaEspacios) {

            espacio.totalOpcionales = 0;

            for (let elemento of espacio.listElementos) {

                if (elemento.checked == true) {
                    espacio.totalOpcionales += elemento.total;
                }

            }

            espacio.total = 0;

            espacio.total = espacio.totalObligatorios + espacio.totalOpcionales;

            if (espacio.checked == true) {
                this.Total += espacio.total;
            }

        }
    }

    /**
    * 
    */
    public onChangeTipoAsistencia(): void {

        switch (this.tipoAsistencia) {
            case '0': this.ConAsistenciaTecnica = this.Total; break;
            case '1': this.ConConstructora = this.Total; break;
        }

        //this.ConAsistenciaTecnica = this.Total * (environment.porcentajeAsistenciaTecnica);

        //this.ConConstructora = this.Total * (environment.porcentajeConstructora);

        switch (this.tipoAsistencia) {
            case '0': this.CostoTotalProyecto = this.ConAsistenciaTecnica; break;
            case '1': this.CostoTotalProyecto = this.ConConstructora; break;
        }
    }



    /**
     * 
     * @param entity
     * @param index
     */
    public onChangeAgregarEtapa(entity: any, index: any): void {
       
        let checked: boolean = false;

        let value: string = entity.value; //event.target['value'];

        if (value == 'true') {
            checked = true;
        }

        entity.checked = checked;

        this.onChangeTipoVivienda();

        this.onChangeAgregarEtapaDos(entity.checked, index);
    }

    /**
     * 
     * @param checked
     * @param index
     */
    private onChangeAgregarEtapaDos(checked: boolean, index: number) {

        let length: number = (this.listEtapas.length - 1);

        if (checked == true) {

            let cont: number = index + 1

            if (cont <= length) {
                this.listEtapas[cont] = false;
            }

        } else {

            let cont: number = index + 1

            if (cont <= length) {

                for (let x = cont; x <= length; x++) {
                    this.listEtapas[x] = true;
                    this.listaEspacios[x].checked = false;
                    this.listaEspacios[x].value = 'false';
                }
            }

        }

    }

    /**
     * 
     */
    public async onChangeTipoVivienda() {

        this.clave = this.getClave();

        await this.onClickCheckboxPrototipo(this.prototipo, false);

        this.onChangeTipoAsistencia();

    }

    /**
     * 
     * @param name
     */
    public changeTab(name: string): void {
        this.activeTab = name;
    }

    /**
     * 
     */
    public EliminarPrototipo() {
        this.prototipo = null;
        this.listaEspacios = [];
        this.itemGroupsPrototipos.length = 0;
        this.activeTab = 'pestana3';
        this.initTotales();
    }

    /**
     * 
     */
    private initTotales(): void {

        this.Total = 0;
        this.CostoTotalProyecto = 0;

        this.Economico = 0;
        this.Medio = 0;
        this.Alto = 0;

        this.ConAsistenciaTecnica = 0;
        this.ConConstructora = 0;

        this.tipoVivienda = '0';
        this.tipoAsistencia = '0';
        this.clave = '';

    }

    /**
    * 
    */
    private getClave(): string {

        let clave: string = '';

        switch (this.tipoVivienda) {
            case '0': clave = ''; break;
            case '1': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 1)[0].clave; break;
            case '2': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 2)[0].clave; break;
        }

        return clave;
    }

    /**
     * 
     */
    private getClavePU(): string {

        let clave: string = '';

        switch (this.tipoAsistencia) {
            case '0': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 4)[0].clave; break;
            case '1': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 5)[0].clave; break;
        }

        return clave;
    }

    /**
     * 
     */
    private getValorClavePU(): number {

        let valor: number = 0;

        switch (this.tipoAsistencia) {
            case '0': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 4)[0].valor; break;
            case '1': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 5)[0].valor; break;
        }

        return valor;
    }

    /**
     * 
     */
    private getValorManoObra(): number {

        let valor: number = this.datosElemento.listParametro.filter(row => row.idParametro == 3)[0].valor;

        return valor;
    }


    /**
     * 
     */
    private getTipoVivienda(): string {

        let tipoVivienda: string = '~~';

        switch (this.tipoVivienda) {
            case '0': tipoVivienda = 'Económico'; break;
            case '1': tipoVivienda = 'Medio'; break;
            case '2': tipoVivienda = 'Alto'; break;
        }

        return tipoVivienda;
    }

    /**
     * 
     */
    private getTipoAsistencia(): string {

        let tipoAsistencia: string = '~~';

        switch (this.tipoAsistencia) {
            case '0': tipoAsistencia = 'Con Asistencia Técnica'; break;
            case '1': tipoAsistencia = ' Con Constructora'; break;
        }

        return tipoAsistencia;
    }

    /**
     * 
     */
    private getListElementosEsp() {

        let listElementosEsp: number[] = [];

        for (let espacio of this.listaEspacios) {

            if (espacio.checked == true) {

                let noSelect = espacio.listElementos.filter(row => row.disabled == false && row.checked == false);

                for (let row of noSelect) {
                    listElementosEsp.push(row.entity.idElementoEsp);
                }
            }
        }

        return listElementosEsp;
    }

    /**
     * 
     */
    private getListEspacios() {

        let listEspacio: number[] = [];

        for (let espacio of this.listaEspacios) {

            if (espacio.checked == false) {

                listEspacio.push(espacio.id);
            }
        }

        return listEspacio;
    }

    /**
     * 
     */
    public async Presupuesto() {

        this.titulo = 'Presupuesto';
        this.modalPresupuesto = true;
        this.modalManoObra = false;
        this.modalMateriales = false;

        // Presupuesto
        {
            this.groupCostoTotalExcelPresupuestoPrototipo = [];

            this.SubTotal = 0;
            this.Indirecto = 0;
            this.$Total = 0;

            let dato: InputObtenerCostoTotalExcelPresupuestoPrototipo = <InputObtenerCostoTotalExcelPresupuestoPrototipo>{
                idPrototipo: this.prototipo.entity.idPrototipo,
                clave: this.getClave(),
                clavePU: this.getClavePU(),
                tablaElementoEsp: this.getListElementosEsp(),
                tablaEspacio: this.getListEspacios(),
            };

            let resultado: JsonResponse<OutputObtenerCostoTotalExcelPresupuestoPrototipo[]> = await this.service.ObtenerCostoTotalExcelPresupuestoPrototipo(dato).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                let listaCostoTotalExcelPresupuestoPrototipo = resultado.model;

                for (let row of listaCostoTotalExcelPresupuestoPrototipo) {
                    this.$Total += row.subtotal;
                }

                this.$Total = this.$Total / 2;

                this.TotalPresupuesto = this.$Total;

                let porcentaje: number = 1 + this.getValorClavePU();

                this.SubTotal = this.$Total / porcentaje;

                this.Indirecto = this.$Total - this.SubTotal;

                this.listaCostoTotalExcelPresupuestoPrototipo = listaCostoTotalExcelPresupuestoPrototipo;

                //{
                //    for (let tipoElemento of this.datosElemento.listTipoElementos) {

                //        let filtro = listaCostoTotalExcelPresupuestoPrototipo.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

                //        if (filtro != null && filtro.length > 0) {

                //            let subTotal: number = 0;

                //            for (let row of filtro) {
                //                subTotal += row.subtotal;
                //            }

                //            let costoTotalExcelPresupuestoPrototipo: CostoTotalExcelPresupuestoPrototipoDTO = { nombreTipoElemento: tipoElemento.nombreTipoElemento, listCostoTotalExcelPresupuestoPrototipo: filtro, subtotal: subTotal };

                //            this.groupCostoTotalExcelPresupuestoPrototipo.push(costoTotalExcelPresupuestoPrototipo);
                //        }

                //    }

                //    if (this.groupCostoTotalExcelPresupuestoPrototipo != null && this.groupCostoTotalExcelPresupuestoPrototipo.length > 0) {

                //        this.listaCostoTotalExcelPresupuestoPrototipo = [];

                //        for (let row of this.groupCostoTotalExcelPresupuestoPrototipo) {

                //            let encabezado: OutputObtenerCostoTotalExcelPresupuestoPrototipo = <OutputObtenerCostoTotalExcelPresupuestoPrototipo>{ nombreTipoElemento: row.nombreTipoElemento };

                //            this.listaCostoTotalExcelPresupuestoPrototipo.push(encabezado);

                //            for (let row2 of row.listCostoTotalExcelPresupuestoPrototipo) {

                //                row2.nombreTipoElemento = null;

                //                this.listaCostoTotalExcelPresupuestoPrototipo.push(row2);
                //            }

                //            let total: OutputObtenerCostoTotalExcelPresupuestoPrototipo = <OutputObtenerCostoTotalExcelPresupuestoPrototipo>{ subtotal: row.subtotal };

                //            this.listaCostoTotalExcelPresupuestoPrototipo.push(total);

                //        }

                //    }
                //}
            }

            this.showModalTotales();
        }

    }

    ///**
    // * 
    // */
    //public async ManoObraMateriales() {

    //    //let idEspacios: number[] = [];
    //    //let listElementos: number[] = [];

    //    //if (this.listaEspacios != null) {

    //    //    for (let espacio of this.listaEspacios) {

    //    //        if (espacio.checked == true) {

    //    //            idEspacios.push(espacio.entity.idEspacio);

    //    //            let filter = espacio.listElementos.filter(row => row.checked == false && row.total > 0);

    //    //            if (filter != null && filter.length > 0) {

    //    //                for (let row of filter) {
    //    //                    listElementos.push(row.entity.idElemento);
    //    //                }

    //    //            }

    //    //        }
    //    //    }

    //    //}

    //}


    /**
     * 
     */
    public async ManoObra() {

        //this.ManoObraMateriales();
        this.titulo = ' Costo total de mano de obra';
        this.modalPresupuesto = false;
        this.modalManoObra = true;
        this.modalMateriales = false;

        // Mano de Obra
        {
            this.Indirecto = 0;
            this.SubTotal = 0;
            this.TotalManoObra = 0;

            //let dato: InputObtenerCostoExcelTotalManoObra = <InputObtenerCostoExcelTotalManoObra>{
            //    idEspacios: idEspacios,
            //    tablaElementos: listElementos
            //};

            let dato: InputObtenerCostoExcelTotalManoObra = <InputObtenerCostoExcelTotalManoObra>{
                idPrototipo: this.prototipo.entity.idPrototipo,
                clave: this.getClave(),
                clavePU: this.getClavePU(),
                tablaElementoEsp: this.getListElementosEsp(),
                tablaEspacio: this.getListEspacios(),
            };

            let resultado: JsonResponse<OutputObtenerCostoExcelTotalManoObra[]> = await this.service.ObtenerCostoExcelTotalManoObra(dato).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.listaCostoExcelTotalManoObra = resultado.model;

                for (let row of this.listaCostoExcelTotalManoObra) {
                    this.TotalManoObra += row.importe;
                }

                let porcentaje: number = 1 + this.getValorManoObra();

                this.SubTotal = this.TotalManoObra / porcentaje;

                this.Indirecto = this.TotalManoObra - this.SubTotal;

            }
        }

        this.showModalTotales();

    }

    /**
     * 
     */
    public async Materiales() {

        //this.ManoObraMateriales();

        this.titulo = ' Costo total de materiales';
        this.modalPresupuesto = false;
        this.modalManoObra = false;
        this.modalMateriales = true;

        // Materiales
        {
            this.TotalMateriales = 0;

            //let dato: InputObtenerCostoExcelExplosionTotalMateriales = <InputObtenerCostoExcelExplosionTotalMateriales>{
            //    idEspacios: idEspacios,
            //    tablaElementos: listElementos,
            //    clave: this.getClave()
            //};

            let dato: InputObtenerCostoExcelExplosionTotalMateriales = <InputObtenerCostoExcelExplosionTotalMateriales>{
                idPrototipo: this.prototipo.entity.idPrototipo,
                clave: this.getClave(),
                clavePU: this.getClavePU(),
                tablaElementoEsp: this.getListElementosEsp(),
                tablaEspacio: this.getListEspacios(),
            };

            let resultado: JsonResponse<OutputObtenerCostoExcelExplosionTotalMateriales[]> = await this.service.ObtenerCostoExcelExplosionTotalMateriales(dato).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.listaCostoExcelExplosionTotalMateriales = resultado.model;

                for (let row of this.listaCostoExcelExplosionTotalMateriales) {
                    this.TotalMateriales += row.importe;
                }

            }
        }

        this.showModalTotales();

    }



    /**
    * 
    */
    public showModalTotales(): void {
        this.modalTotales = true;
    }

    /**
     * 
     */
    public closeModal(): void {
        this.modalTotales = false;
    }

    /**
     * 
     */
    public async downloadReporte() {

        let parametros: Totales = <Totales>{
            totalMateriales: this.TotalMateriales,
            totalManoObra: this.TotalManoObra,
            totalPresupuesto: this.TotalPresupuesto,
            total: this.CostoTotalProyecto,
            tipoVivienda: this.getTipoVivienda(),
            tipoAsistencia: this.getTipoAsistencia()
        };

        let datosReporte: InputObtenerReportePrototipo = <InputObtenerReportePrototipo>{
            idPrototipo: this.prototipo.entity.idPrototipo,
            clave: this.getClave(),
            clavePU: this.getClavePU(),
            listEspacios: [],
            parametros: parametros,
            tablaElementoEsp: this.getListElementosEsp(),
            tablaEspacio: this.getListEspacios(),
        }

        if (this.listaEspacios != null) {

            for (let espacio of this.listaEspacios) {

                if (espacio.checked == true) {

                    let espacios: Espacios = <Espacios>{
                        idEspacio: espacio.entity.idEspacio,
                        listElementos: [],
                    };

                    let filter = espacio.listElementos.filter(row => row.checked == false && row.total > 0);

                    let listElementos: number[] = [];

                    if (filter != null && filter.length > 0) {

                        for (let row of filter) {
                            listElementos.push(row.entity.idElemento);
                        }

                    }

                    espacios.listElementos = listElementos;

                    datosReporte.listEspacios.push(espacios);

                }
            }

        }

        if (datosReporte != null) {

            let resultado: JsonResponse<string> = await this.service.ObtenerReportePrototipo(datosReporte).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {
                window.open(resultado.model);
            } else {
                console.error('Error en Reporte Prototipo -->> ', resultado);
            }
        }

    }


    /** para que se vaya al html bookmark del calculo arriba **/
    scrollToElement($element): void {
        console.log($element);
        $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    /**
     * 
     * @param idEspacio
     * @param idEtapaPrototipo
     */
    public verPlano(idEspacio?: number, idEtapaPrototipo?: number) {

        this.tituloModal = `Plano - Etapa ${idEtapaPrototipo}`;

        this.listDocument = [];

        let filter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 3 && row.idEspacio == idEspacio);

        //Etapa 1

        if (idEspacio == null) {

            let subFilter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 3);

            if (subFilter != null && subFilter.length > 0) {

                subFilter = subFilter.sort(row => row.idEspacio)

                filter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 3 && row.idEspacio == subFilter[0].idEspacio);
            }
        }

        this.listDocument.push(...filter);
    }

    /**
     * 
     * @param idEspacio
     * @param idEtapaPrototipo
     */
    public queIncluye(idEspacio?: number, idEtapaPrototipo?: number) {

        this.tituloModal = `¿Qué incluye? - Etapa ${idEtapaPrototipo}`;

        this.listDocument = [];

        let filter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 4 && row.idEspacio == idEspacio);

        //Etapa 1

        if (idEspacio == null) {

            let subFilter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 4);

            if (subFilter != null && subFilter.length > 0) {

                subFilter = subFilter.sort(row => row.idEspacio)

                filter = this.listaDocumentos.listDocumentXEtapa.filter(row => row.idCatalogoDocumento == 4 && row.idEspacio == subFilter[0].idEspacio);
            }
        }

        this.listDocument.push(...filter);

    }

    /**
     * 
     * @param label
     * @param rutaArchivo
     */
    public ampliarImagen(label: string, rutaArchivo: string) {

        this.tituloModal = `${label}`;

        this.listDocument = [];

        let docuemntosXPrototipo: OutputObtenerDocuemntosXPrototipo = <OutputObtenerDocuemntosXPrototipo>{ rutaArchivo: rutaArchivo };

        this.listDocument.push(docuemntosXPrototipo);
    }

    /**
     * 
     * @param entity
     */
    public downloadDocumento(entity: OutputObtenerDocuemntosXPrototipo) {
        window.open(entity.rutaArchivo);
    }

}
